// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { spacing } from '../../tokens/spacing';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var SIDE_PANEL_SHADOW = '0px 0px 12px rgba(0, 0, 0, 0.2)';
export var APP_BAR_SHADOW = '0px 1px 4px rgba(0, 0, 0, 0.2)';
export var drawerHeaderSx = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        backgroundColor: bg.level0,
        borderBottom: "".concat(rem(1), " solid ").concat(bd.default),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: rem(84),
        overflow: 'clip',
        paddingX: rem(spacing[4]),
        paddingY: rem(spacing[6]),
        color: tx.primary
    };
};
export var drawerActionsSx = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    return {
        backgroundColor: bg.level50,
        borderTop: "".concat(rem(1), " solid ").concat(bd.default),
        boxShadow: APP_BAR_SHADOW,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: rem(spacing[2]),
        height: rem(84),
        overflow: 'clip',
        paddingX: rem(spacing[4]),
        paddingY: rem(spacing[6])
    };
};
export var Drawer = function(_mode) {
    var bg = background(_mode);
    var bd = border(_mode);
    var override = {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    width: rem(480),
                    backgroundColor: bg.level0,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    borderRadius: 0,
                    boxSizing: 'border-box',
                    overflowY: 'auto'
                },
                paperAnchorLeft: {
                    borderRight: "".concat(rem(1), " solid ").concat(bd.default)
                },
                paperAnchorRight: {
                    borderLeft: "".concat(rem(1), " solid ").concat(bd.default)
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Drawer.js.map